/**
 * TanStack Query hooks for `agent-driven-campaign-optimization-ai-native`.
 * Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	applySuggestion,
	dismissSuggestion,
	list,
	agentDrivenOptimizationQueryKeys,
	type ListOptimizationResponse,
	type PatchOptimizationResult,
} from "./api";

export function useOptimizationList(): UseQueryResult<
	ListOptimizationResponse,
	Error
> {
	return useQuery({
		queryKey: agentDrivenOptimizationQueryKeys.list(),
		queryFn: list,
	});
}

export function useApplySuggestion(): UseMutationResult<
	PatchOptimizationResult,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: applySuggestion,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: agentDrivenOptimizationQueryKeys.all,
			});
		},
	});
}

export function useDismissSuggestion(): UseMutationResult<
	PatchOptimizationResult,
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: dismissSuggestion,
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: agentDrivenOptimizationQueryKeys.all,
			});
		},
	});
}
